import LandingPageHeader from './landing-page-header'

export default LandingPageHeader
